import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  notificationsPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  createNotification,
  fetchClasses,
  CREATE_NOTIFICATION_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import NotificationForm from "../../../templates/manager/NotificationForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === CREATE_NOTIFICATION_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(notificationsPath);
    }
  }, [history, dispatch, state.success_message]);

  const createNotificationFunc = React.useCallback(
    (notification: {
      id: number;
      content: string;
      for_teacher: boolean;
      class_ids: number[];
    }) => {
      dispatch(peep(createNotification(notification)));
    },
    [dispatch, peep],
  );

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  return (
    <div>
      <Breadcrumb
        links={[{ title: titles.notifications, to: notificationsPath }]}
        currentTitle={titles.newNotification}
      />
      <NotificationForm
        title={titles.newNotification}
        calling={calling}
        classes={state.classes}
        error={state.error}
        upsertNotification={createNotificationFunc}
      />
    </div>
  );
};
